import { $t, $tc } from '@/app-bootstrapping/SetUpInternationalization'

// Standard composable for setup()
export function useTranslation() {
  return { $t, $tc }
}
// For direct method usage not using setup()
export { $t, $tc }
